/** Injected at build time from package.json (see vite.config.ts). */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export function logAppVersion(): void {
  console.info(`[pickle-event] v${APP_VERSION}`);
}
